const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export const moneyFormat = (amount: number) => {
  return formatter.format(amount);
};

export const centsToDollars = (cents?: number | null) => {
  return cents ? cents / 100 : 0;
};

export const formatPrice = (value: number | string | null | undefined): string | null => {
  if (value === null || value === undefined) return null;
  const cents = Number(value);
  if (Number.isNaN(cents)) return null;
  return moneyFormat(centsToDollars(cents));
};
